import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { IcSecureE2ee16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes, InfoBlock, InfoBlockTypes } from '@gem/ui-kit';

import { ChatBackground } from 'APP/main/components/ChatBackground/ChatBackground';

import styles from './SecretChatMessagesEmpty.styles.m.css';

export const SecretChatMessagesEmpty: FC = observer(() => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <ChatBackground />
      <InfoBlock
        className={styles.infoBlock}
        title={t('secure_chat_onboarding_title')}
        descriptions={[
          <span className={styles.descriptionContainer}>
            <IconView
              className={styles.icon}
              Icon={IcSecureE2ee16Icon}
              size={IconViewSizes.Small}
            />
            {t('secure_chat_onboarding_description_a')}
          </span>,
          <span className={styles.descriptionContainer}>
            <IconView
              className={styles.icon}
              Icon={IcSecureE2ee16Icon}
              size={IconViewSizes.Small}
            />
            {t('secure_chat_onboarding_description_b')}
          </span>,
          <span className={styles.descriptionContainer}>
            <IconView
              className={styles.icon}
              Icon={IcSecureE2ee16Icon}
              size={IconViewSizes.Small}
            />
            {t('secure_chat_sync_requires_active_device_bullet')}
          </span>,
          <span className={styles.descriptionContainer}>
            <IconView
              className={styles.icon}
              Icon={IcSecureE2ee16Icon}
              size={IconViewSizes.Small}
            />
            {t('secure_chat_history_unavailable_banner')}
          </span>,
        ]}
        type={InfoBlockTypes.Chat}
      />
    </div>
  );
});
